import Vue from 'vue';
import InitLayout from '@/layouts/Init.vue';
import UserLayout from '@/layouts/User.vue';
import MainLayout from '@/layouts/Main.vue';
import AuthLayout from '@/layouts/Auth.vue';
import SvgIcon from '@/components/common/SvgIcon.vue';
import SearchInput from '@/components/common/SearchInput.vue';
import Dialog from '@/components/common/Dialog.vue';
import DatePicker from '@/components/common/DatePicker.vue';
import Snackbar from '@/components/common/Snackbar.vue';
import ProgressCircular from '@/components/common/ProgressCircular.vue';

Vue.component('init-layout', InitLayout);
Vue.component('user-layout', UserLayout);
Vue.component('auth-layout', AuthLayout);
Vue.component('main-layout', MainLayout);
Vue.component('svg-icon', SvgIcon);
Vue.component('search-input', SearchInput);
Vue.component('user-dialog', Dialog);
Vue.component('date-picker', DatePicker);
Vue.component('snack-bar', Snackbar);
Vue.component('progress-circular', ProgressCircular);
